export default __webpack_public_path__ + "static/media/soft-launch-revsharebg.95209489.jpg";